import { render, staticRenderFns } from "./ReleaseNoteDelete.vue?vue&type=template&id=663f5c09"
import script from "./ReleaseNoteDelete.vue?vue&type=script&lang=js"
export * from "./ReleaseNoteDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports